import { useLocation } from 'react-router-dom';
import { useTour } from '@/providers/TourProvider';
import { type TourSection } from '@/config/tours';

export interface RouteHelp {
  // Secciones de ayuda registradas para la ruta actual.
  sections: TourSection[];
  // Recorre todas las secciones de la ruta actual.
  runFullTour: () => void;
  // Recorre una sola sección de la ruta actual.
  runSection: (sectionId: string) => void;
  runOnboarding: () => void;
}

// Ayuda contextual de la página actual, con las acciones ya atadas a la ruta.
// La usan el botón "?" de la barra y el submenú "Ayuda de esta página" del
// menú de usuario en el celular, así los dos ofrecen lo mismo.
export function useRouteHelp(): RouteHelp {
  const { pathname } = useLocation();
  const { runOnboarding, runSection, runFullTour, sectionsForRoute } = useTour();
  return {
    sections: sectionsForRoute(pathname),
    runFullTour: () => runFullTour(pathname),
    runSection: (sectionId) => runSection(pathname, sectionId),
    runOnboarding,
  };
}
